const shortenTitle = ({ title, index }) => `${title.substring(0, index)}...`

export default shortenTitle;